module.exports = __webpack_public_path__ + "media/images/btn_save-6aa83cd738ec9b949d9f1a1b0da13f6e.gif";